export default function isObject(obj) {
  return obj !== null && typeof obj === 'object' && obj.toString() === '[object Object]';
}